<ul *adaptLoadingUntilFirstEmit="let locations of parentsOfLinks$">
    <li *ngFor="let location of locations">
        <adapt-link-process-map [processMap]="location.processMap"></adapt-link-process-map>
        <adapt-process-step-card *ngIf="location.parentProcessStep"
                                 [processStep]="location.parentProcessStep"></adapt-process-step-card>
    </li>
</ul>
